<div class="ion-padding" class="container-flex">

    <button class="bt-close">
        <ion-icon name="close-circle" (click)="close()"></ion-icon>
    </button>

    <h2 class="title">Enter your email below to retrieve your password</h2>

    <form [formGroup]="forgotenForm">
        <ion-item>
            <ion-label>
                <ion-icon name="mail"></ion-icon> Email
            </ion-label>
            <ion-input type="email" formControlName="email"></ion-input>
        </ion-item>
        <app-field-validator [fieldControl]="forgotenForm.controls['email']"></app-field-validator>
    </form>

    <ion-button class="ion-margin-top" color="primary" [disabled]="forgotenForm.invalid" 
    expand="full" (click)="sendForm()">Send</ion-button>
    
</div>